import { writable,readable } from 'svelte/store';

export const selectedTagIds = writable([]);
export const selectedTags = writable([]);

export const selectedCateIds = writable([]);
export const selectedCates = writable([]);